export interface InvoiceUploadStatus {
  uploadTimestamp: string;
  invoiceId: string | undefined;
  status: string;
  fileName: string;
}

export function storeObjectsInLocal(
  key: string,
  objects: InvoiceUploadStatus[],
) {
  const serializedObjects = JSON.stringify(objects);
  localStorage.setItem(key, serializedObjects);
}

export function addObjectToLocal(key: string, object: InvoiceUploadStatus) {
  const objects = retrieveObjectsFromLocal(key);
  if (objects.length === 0) {
    storeObjectsInLocal(key, [object]);
    return;
  }
  objects.push(object);
  storeObjectsInLocal(key, objects);
  const event = new Event("invoiceChangedLocalStorage");
  document.dispatchEvent(event);
}

export function retrieveObjectsFromLocal(key: string) {
  const serializedObjects = localStorage.getItem(key);
  if (serializedObjects) {
    return JSON.parse(serializedObjects);
  }
  return []; // Return an empty array if nothing is stored
}

export function removeObjectFromLocalStorageByTimeStamp(
  key: string,
  timeStamp: string,
) {
  console.log("removeObjectFromLocalStorageByInvoiceId", timeStamp);
  const objects: InvoiceUploadStatus[] = retrieveObjectsFromLocal(key);
  const objectIndex = objects.findIndex(
    (obj) => obj.uploadTimestamp === timeStamp,
  );
  if (objectIndex !== -1) {
    console.log("removed object from local storage");
    objects.splice(objectIndex, 1);
    storeObjectsInLocal(key, objects); // Store the updated array back into local storage
  }
  const event = new Event("invoiceChangedLocalStorage");
  document.dispatchEvent(event);
}

export function editObjectInLocalStorageByInvoiceId(
  key: string,
  invoiceId: string,
  newStatus: string,
) {
  const objects: InvoiceUploadStatus[] = retrieveObjectsFromLocal(key);
  const objectIndex = objects.findIndex((obj) => obj.invoiceId === invoiceId);
  if (objectIndex !== -1) {
    objects[objectIndex].status = newStatus;
    storeObjectsInLocal(key, objects); // Store the updated array back into local storage
  }
  const event = new Event("invoiceChangedLocalStorage");
  document.dispatchEvent(event);
}

export function editObjectInLocalStorageByTimeStamp(
  key: string,
  uploadTimestamp: string,
  newStatus: string,
  invoiceId: string | undefined,
) {
  const objects: InvoiceUploadStatus[] = retrieveObjectsFromLocal(key);
  const objectIndex = objects.findIndex(
    (obj) => obj.uploadTimestamp === uploadTimestamp,
  );
  if (objectIndex !== -1) {
    objects[objectIndex].status = newStatus;
    objects[objectIndex].invoiceId = invoiceId;
    storeObjectsInLocal(key, objects); // Store the updated array back into local storage
  }
  const event = new Event("invoiceChangedLocalStorage");
  document.dispatchEvent(event);
}

export function clearLocalStorage(key: string) {
  localStorage.setItem(key, JSON.stringify([]));
  const event = new Event("invoiceChangedLocalStorage");
  document.dispatchEvent(event);
}
